import { MouseEvent } from 'react';
import { Button } from 'reactstrap';
import { ButtonMetadata, ButtonType } from '../button-types';
import styles from './icons-button.module.scss';

export const IconsButton = ({
  meta,
  classes,
  onClick,
  children,
}: {
  meta: ButtonMetadata
  classes?: string[]
  onClick?: (e: MouseEvent) => void
  children?: JSX.Element | string
}) => {
  const analyticsTags = (meta: ButtonMetadata) => {
    return {
      'data-component-name': `${meta.areaName}`,
      'data-component-info': `{
        'name': '${meta.name}',
        'componentName': '${meta.componentName}',
        'targetPageUrl': '${meta.targetUrl}',
        'text': '${meta.title}'
      }`,
    }
  }

  return (
    <Button
      className={[...(classes || []), meta.type ? styles[meta.type] : styles[ButtonType.Primary]].join(' ')}
      onClick={onClick}
      {...analyticsTags(meta)}
    >
      <i className={`${meta.iconName} ${styles.btnIcon}`}></i>
      {children || meta.title}
    </Button>
  );
}